module.exports = __webpack_public_path__ + "img/qqgroup.0346c28e.png";